import { RefObject, useEffect } from 'react';

import { VISIBILITY_CHECK_INTERVAL_MS } from './consts';
import isElementVisible from './isElementVisible';

type UseCloseWhenHiddenParams = {
  isActive: boolean;
  triggerRef: RefObject<HTMLElement | null>;
  onHidden: () => void;
};

const useCloseWhenHidden = ({ isActive, triggerRef, onHidden }: UseCloseWhenHiddenParams) => {
  useEffect(() => {
    if (!isActive) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      const trigger = triggerRef.current;

      if (!trigger || !isElementVisible(trigger)) {
        onHidden();
      }
    }, VISIBILITY_CHECK_INTERVAL_MS);

    return () => window.clearInterval(intervalId);
  }, [isActive, triggerRef, onHidden]);
};

export default useCloseWhenHidden;
